import { App, createApp } from 'proposal_collection/motion.mts'

if (document.getElementById("app")) {
    const app = createApp(App)
    app.mount('#app')
}
